import { useFilterConfig } from '../hooks/useFilterConfig';
import { SelectFilter } from './reusableFilters/SelectFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SolutionsPartnerFilterControls() {
  const {
    PROFILE_ACCREDITATIONS,
    PROFILE_BUDGET,
    PROFILE_CERTIFICATIONS,
    PROFILE_LANGUAGES: __PROFILE_LANGUAGES,
    PROFILE_LOCATION_COUNTRY: __PROFILE_LOCATION_COUNTRY,
    PROFILE_OFFICE_LOCATION,
    PROFILE_SOLUTIONS_PARTNER_TIER,
    PROFILE_SUPPORTED_LISTINGS: __PROFILE_SUPPORTED_LISTINGS
  } = useFilterConfig();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SelectFilter, {
      filter: PROFILE_ACCREDITATIONS
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: PROFILE_OFFICE_LOCATION
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: PROFILE_BUDGET
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: PROFILE_CERTIFICATIONS
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: PROFILE_SOLUTIONS_PARTNER_TIER
    })]
  });
}